import { fetchOpportunityCountApi } from "../../../../network/service";
import { fetchLeadIdFromURL, getUserStandardTimeZone } from "../../../../utils/helpers";

const fetchOpportunityCount = async (config) => {
    try {
      const body = {
        PageIndex: 1,
        PageSize: 1,
        Columns: "Status",
        SearchText: "",
        IsOpportunity: true,
        SortOn: "CreatedOn",
        SortBy: 1,
      };
      const customFilters = {
        GrpConOp: "and",
        QueryTimeZone: getUserStandardTimeZone(),
        Conditions: [],
      };
  
      body.CustomFilters = JSON.stringify(customFilters);
  
      const advancedSearch = {
        GrpConOp: "and",
        Conditions: [
          {
            Type: "Activity",
            ConOp: "and",
            RowCondition: [
              {
                SubConOp: "and",
                LSO: "ActivityEvent",
                LSO_Type: "PAEvent",
                Operator: "eq",
                RSO: config?.opportunityTypes?.[0]?.code,
                RSO_IsMailMerged: false,
              },
            ],
          },
          {
            Type: "Activity",
            ConOp: "and",
            RowCondition: [
              {
                SubConOp: "and",
                LSO: "RelatedProspectId",
                LSO_Type: "String",
                Operator: "eq",
                RSO: fetchLeadIdFromURL(),
                RSO_IsMailMerged: false,
              },
            ],
          },
        ],
      };
      body.AdvancedSearch = JSON.stringify(advancedSearch);
      const response = await fetchOpportunityCountApi(body);
      if (response.status !== 200)
        throw new Error("Failed to fetch opportunity count");
      return response.data?.RecordCount;
    } catch (error) {
      console.error(error);
      throw new Error(error.message);
    }
  };

  export default fetchOpportunityCount;